import { IShellEvent } from './IShellEvent';
import { ShellCommunicationEvents } from '@shared/generalInterfaces';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BackButtonClickedEvent implements IShellEvent {
	get eventName(): string {
		return ShellCommunicationEvents.BackButtonClicked;
	}

	async handleCustomEvent(event: any, publishEventFunc: (eventName: string, targetApplications: Array<string>, eventPayload?: any) => Promise<void>) {
	}

	handlePostMessage(event): void {}
}
